import React from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";

// const debug = "FieldItemModelStoryPointsCalculated_TableCell"
const debug = false


export default function FieldTaskId_TableCell(props:FieldTableCellProps) {

    return (
        <div className="cell-flex" style={getTableCellStyle(props)}>
            {props.listItem.task.shortId &&
                <div className="ui5-property short-id-label">#{props.listItem.task.shortId}</div>
            }
        </div>
    )


}

